import classNames from 'classnames';
import React, { FC } from 'react';

import { Avatar, Flag } from '@whitesharx/starfall-frontend-ui-kit';

import { cardStyles, imageContainerStyles, textStyles } from '../styles.css';
import { textFieldStyles, nameStyles, flagContainerStyles } from './styles.css';

export type Player = {
  avatarSrc?: string;
  setName?: string;
  name?: string;
  country?: string;
};

const PlayerCard: FC<Player> = ({ avatarSrc, setName, name, country }) => (
  <div className={cardStyles}>
    <div className={imageContainerStyles}>
      <Avatar src={avatarSrc} size="100%" frame={setName} />
    </div>
    <div className={classNames(textFieldStyles, textStyles)}>
      <div className={nameStyles}>{name}</div>
      {country && (
        <div className={flagContainerStyles}>
          <Flag size={21} country={country} />
        </div>
      )}
    </div>
  </div>
);

export default PlayerCard;
